import { Exception, type TExceptionParams } from './Exception'

const HTTPExceptionStatuses: Record<number, string> = {
  400: 'BadRequest',
  401: 'Unauthorized',
  403: 'Forbidden',
  404: 'NotFound',
  405: 'NotAllowed',
  406: 'NotAcceptable',
  407: 'ProxyAuthenticationRequired',
  408: 'RequestTimeout',
  409: 'Conflict',
  410: 'Gone',
  411: 'LengthRequired',
  412: 'PreconditionFailed',
  413: 'PayloadTooLarge',
  414: 'URITooLarge',
  415: 'UnsupportedMediaType',
  416: 'RangeNotSatisfiable',
  417: 'ExpectationFailed',
  418: 'Teapot',
  421: 'MisdirectedRequest',
  422: 'UnprocessableEntity',
  423: 'Locked',
  424: 'FailedDependency',
  425: 'TooEarly',
  426: 'UpgradeRequired',
  428: 'PreconditionRequired',
  429: 'TooManyRequests',
  431: 'RequestHeaderFieldsTooLarge',
  444: 'NoResponse',
  451: 'UnavailableForLegalReasons',
  495: 'SSLCertificateError',
  496: 'SSLCertificateRequired',
  497: 'HTTPRequestSentToHTTPSPort',
  499: 'ClientClosedRequest',
  500: 'InternalServer',
  501: 'NotImplemented',
  502: 'BadGateway',
  503: 'ServiceUnavailable',
  504: 'GatewayTimeout',
  505: 'HTTPVersionNotSupported',
  506: 'VariantAlsoNegotiates',
  507: 'InsufficientStorage',
  508: 'LoopDetected',
  510: 'NotExtended',
  511: 'NetworkAuthenticationRequired',
  521: 'WebServerIsDown',
  522: 'ConnectionTimedOut',
  523: 'OriginIsUnreachable',
  524: 'TimeoutOccurred',
  525: 'SSLHandshakeFailed',
  526: 'InvalidSSLCertificate',
  527: 'RailgunError',
}

const getDefaultHTTPExceptionMessage = (status: number) =>
  HTTPExceptionStatuses[status]?.replace(/([a-z])([A-Z])/g, '$1 $2') ?? 'Unknown'

type THTTPExceptionParams = TExceptionParams & {
  status: number
}

export class HTTPException extends Exception {
  public status: number

  constructor({ cause, status, message = getDefaultHTTPExceptionMessage(status) }: THTTPExceptionParams) {
    super({ message, cause })
    this.status = status
    this.name = HTTPExceptionStatuses[status] ?? 'Unknown'
  }
}
